<template>
  <div id="Alerts">
    <div class="settings_view">
      <div class="default_top">
        <div>
          <span>Alerts</span>
        </div>
        <div></div>
      </div>

      <div class="content_subscriptions">
        <div class="row">
          <div class="col-6">
            <div class="title">
              <span>Alerts</span>
            </div>
            <div class="sub_title">
              <span>Email me when</span>
            </div>
            <div class="subscriptions_content">
              <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                value="accepted"
              >I delete a large number of file</b-form-checkbox>
              <b-form-checkbox
                id="checkbox-2"
                name="checkbox-2"
                value="accepted"
              >A new browser is used to sign in</b-form-checkbox>
              <b-form-checkbox
                id="checkbox-3"
                name="checkbox-3"
                value="accepted"
              >A new device is linked</b-form-checkbox>
            </div>
          </div>
          <div class="col-6">
            <div class="title">
              <span>Files</span>
            </div>
            <div class="sub_title">
              <span>Email me about</span>
            </div>
            <div class="subscriptions_content">
              <b-form-checkbox
                id="checkbox-4"
                name="checkbox-4"
                value="accepted"
              >Activity in shared folder</b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="title">
              <span>News</span>
            </div>
            <div class="sub_title">
              <span>Email me about</span>
            </div>
            <div class="subscriptions_content">
              <b-form-checkbox
                id="checkbox-5"
                name="checkbox-5"
                value="accepted"
              >New features and updates</b-form-checkbox>
            </div>
          </div>
          <div class="col-6">
            <div class="title">
              <span>Paper</span>
            </div>
            <div class="sub_title">
              <span>Email me about</span>
            </div>
            <div class="subscriptions_content">
              <b-form-checkbox id="checkbox-6" name="checkbox-6" value="accepted">Changes to docs</b-form-checkbox>
              <b-form-checkbox id="checkbox-7" name="checkbox-7" value="accepted">Doc activity</b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alerts",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
